import { useCallback, useState } from 'react';

const MOCK_RESPONSE = {
  page: 1,
  limit: 15,
  total: 86222,
  totalFiltered: 84544,
  totalComplete: 0,
  response: [
    {
      _id: '698aef1e98b7550011723ad8',
      id: '698aef1e98b7550011723ad8',
      rate: 25,
      profession: 'DA',
      subProfession: null,
      job_status: 'open',
      status: 'open',
      is_cancelled: false,
      offer_owner: {
        _id: '65833147094d4d001184f4ad',
        id: '65833147094d4d001184f4ad',
        address: [{ city: 'Miami', state: 'FL' }],
        office_name: 'test',
      },
      offer_final_reciever: null,
      job_datetime: '2026-03-04T14:00:00.000Z',
      job_filled_datetime: null,
      workerClassification: 'contractor',
      createdAt: '2026-02-10T08:41:02.035Z',
      workingHours: 6,
      local_start_time: '09:00 am',
      local_end_time: '04:00 pm',
      local_date: 'Wed, Mar 04, 2026',
      counterExpirationTime: '',
    },
    {
      _id: '698aef1e98b7550011723ad2',
      id: '698aef1e98b7550011723ad2',
      rate: 25,
      profession: 'DA',
      subProfession: null,
      job_status: 'open',
      status: 'open',
      is_cancelled: false,
      offer_owner: {
        _id: '65833147094d4d001184f4ad',
        id: '65833147094d4d001184f4ad',
        address: [{ city: 'Miami', state: 'FL' }],
        office_name: 'test',
      },
      offer_final_reciever: null,
      job_datetime: '2026-03-02T14:00:00.000Z',
      job_filled_datetime: null,
      workerClassification: 'contractor',
      createdAt: '2026-02-10T08:41:02.035Z',
      workingHours: 6,
      local_start_time: '09:00 am',
      local_end_time: '04:00 pm',
      local_date: 'Mon, Mar 02, 2026',
      counterExpirationTime: '',
    },
    {
      _id: '698aef1e98b7550011723ad5',
      id: '698aef1e98b7550011723ad5',
      rate: 25,
      profession: 'DA',
      subProfession: null,
      job_status: 'open',
      status: 'open',
      is_cancelled: false,
      offer_owner: {
        _id: '65833147094d4d001184f4ad',
        id: '65833147094d4d001184f4ad',
        address: [{ city: 'Miami', state: 'FL' }],
        office_name: 'test',
      },
      offer_final_reciever: null,
      job_datetime: '2026-03-03T14:00:00.000Z',
      job_filled_datetime: null,
      workerClassification: 'contractor',
      createdAt: '2026-02-10T08:41:02.035Z',
      workingHours: 6,
      local_start_time: '09:00 am',
      local_end_time: '04:00 pm',
      local_date: 'Tue, Mar 03, 2026',
      counterExpirationTime: '',
    },
    {
      _id: '698aef1e98b7550011723b01',
      id: '698aef1e98b7550011723b01',
      rate: 40,
      profession: 'RDH',
      subProfession: null,
      job_status: 'filled',
      status: 'filled',
      is_cancelled: false,
      offer_owner: {
        _id: '65833147094d4d001184f4ae',
        id: '65833147094d4d001184f4ae',
        address: [{ city: 'Orlando', state: 'FL' }],
        office_name: 'Bright Smiles Dental',
      },
      offer_final_reciever: {
        _id: '65833147094d4d001184f500',
        id: '65833147094d4d001184f500',
        first_name: 'Jane',
        last_name: 'Doe',
      },
      job_datetime: '2026-03-05T13:00:00.000Z',
      job_filled_datetime: '2026-02-09T15:30:00.000Z',
      workerClassification: 'contractor',
      createdAt: '2026-02-08T10:20:00.000Z',
      workingHours: 8,
      local_start_time: '08:00 am',
      local_end_time: '05:00 pm',
      local_date: 'Thu, Mar 05, 2026',
      counterExpirationTime: '',
    },
    {
      _id: '698aef1e98b7550011723b02',
      id: '698aef1e98b7550011723b02',
      rate: 35,
      profession: 'RDH',
      subProfession: null,
      job_status: 'cancelled',
      status: 'cancelled',
      is_cancelled: true,
      offer_owner: {
        _id: '65833147094d4d001184f4af',
        id: '65833147094d4d001184f4af',
        address: [{ city: 'Tampa', state: 'FL' }],
        office_name: 'Tampa Family Dental',
      },
      offer_final_reciever: null,
      job_datetime: '2026-03-06T14:00:00.000Z',
      job_filled_datetime: null,
      workerClassification: 'contractor',
      createdAt: '2026-02-07T09:15:00.000Z',
      workingHours: 7,
      local_start_time: '09:00 am',
      local_end_time: '04:00 pm',
      local_date: 'Fri, Mar 06, 2026',
      counterExpirationTime: '',
    },
    {
      _id: '698aef1e98b7550011723b03',
      id: '698aef1e98b7550011723b03',
      rate: 30,
      profession: 'DA',
      subProfession: 'EFDA',
      job_status: 'complete',
      status: 'complete',
      is_cancelled: false,
      offer_owner: {
        _id: '65833147094d4d001184f4b0',
        id: '65833147094d4d001184f4b0',
        address: [{ city: 'Jacksonville', state: 'FL' }],
        office_name: 'Jax Dental Care',
      },
      offer_final_reciever: {
        _id: '65833147094d4d001184f501',
        id: '65833147094d4d001184f501',
        first_name: 'Sarah',
        last_name: 'Smith',
      },
      job_datetime: '2026-02-01T14:00:00.000Z',
      job_filled_datetime: '2026-01-28T12:00:00.000Z',
      workerClassification: 'contractor',
      createdAt: '2026-01-25T08:00:00.000Z',
      workingHours: 6,
      local_start_time: '09:00 am',
      local_end_time: '04:00 pm',
      local_date: 'Sun, Feb 01, 2026',
      counterExpirationTime: '',
    },
    {
      _id: '698aef1e98b7550011723b04',
      id: '698aef1e98b7550011723b04',
      rate: 28,
      profession: 'DA',
      subProfession: null,
      job_status: 'pending',
      status: 'pending',
      is_cancelled: false,
      offer_owner: {
        _id: '65833147094d4d001184f4b1',
        id: '65833147094d4d001184f4b1',
        address: [{ city: 'Fort Lauderdale', state: 'FL' }],
        office_name: 'Sunrise Dental',
      },
      offer_final_reciever: null,
      job_datetime: '2026-03-10T15:00:00.000Z',
      job_filled_datetime: null,
      workerClassification: 'contractor',
      createdAt: '2026-02-09T14:30:00.000Z',
      workingHours: 5,
      local_start_time: '10:00 am',
      local_end_time: '03:00 pm',
      local_date: 'Tue, Mar 10, 2026',
      counterExpirationTime: '',
    },
    {
      _id: '698aef1e98b7550011723b05',
      id: '698aef1e98b7550011723b05',
      rate: 45,
      profession: 'RDH',
      subProfession: null,
      job_status: 'pay-out',
      status: 'pay-out',
      is_cancelled: false,
      offer_owner: {
        _id: '65833147094d4d001184f4b2',
        id: '65833147094d4d001184f4b2',
        address: [{ city: 'Naples', state: 'FL' }],
        office_name: 'Gulf Coast Dental',
      },
      offer_final_reciever: {
        _id: '65833147094d4d001184f502',
        id: '65833147094d4d001184f502',
        first_name: 'Emily',
        last_name: 'Johnson',
      },
      job_datetime: '2026-02-05T14:00:00.000Z',
      job_filled_datetime: '2026-02-03T10:00:00.000Z',
      workerClassification: 'contractor',
      createdAt: '2026-02-01T09:00:00.000Z',
      workingHours: 8,
      local_start_time: '08:00 am',
      local_end_time: '05:00 pm',
      local_date: 'Thu, Feb 05, 2026',
      counterExpirationTime: '',
    },
    {
      _id: '698aef1e98b7550011723b06',
      id: '698aef1e98b7550011723b06',
      rate: 32,
      profession: 'DA',
      subProfession: null,
      job_status: 'expired',
      status: 'expired',
      is_cancelled: false,
      offer_owner: {
        _id: '65833147094d4d001184f4b3',
        id: '65833147094d4d001184f4b3',
        address: [{ city: 'Sarasota', state: 'FL' }],
        office_name: 'Sarasota Smiles',
      },
      offer_final_reciever: null,
      job_datetime: '2026-02-08T14:00:00.000Z',
      job_filled_datetime: null,
      workerClassification: 'contractor',
      createdAt: '2026-02-04T11:00:00.000Z',
      workingHours: 7,
      local_start_time: '09:00 am',
      local_end_time: '04:00 pm',
      local_date: 'Sun, Feb 08, 2026',
      counterExpirationTime: '',
    },
    {
      _id: '698aef1e98b7550011723b07',
      id: '698aef1e98b7550011723b07',
      rate: 38,
      profession: 'RDH',
      subProfession: null,
      job_status: 'counter',
      status: 'counter',
      is_cancelled: false,
      offer_owner: {
        _id: '65833147094d4d001184f4b4',
        id: '65833147094d4d001184f4b4',
        address: [{ city: 'St. Petersburg', state: 'FL' }],
        office_name: 'Bay Dental Group',
      },
      offer_final_reciever: null,
      job_datetime: '2026-03-12T13:00:00.000Z',
      job_filled_datetime: null,
      workerClassification: 'contractor',
      createdAt: '2026-02-09T16:00:00.000Z',
      workingHours: 8,
      local_start_time: '08:00 am',
      local_end_time: '05:00 pm',
      local_date: 'Thu, Mar 12, 2026',
      counterExpirationTime: 'PT2H30M',
    },
    {
      _id: '698aef1e98b7550011723b08',
      id: '698aef1e98b7550011723b08',
      rate: 27,
      profession: 'DA',
      subProfession: null,
      job_status: 'open',
      status: 'open',
      is_cancelled: false,
      offer_owner: {
        _id: '65833147094d4d001184f4b5',
        id: '65833147094d4d001184f4b5',
        address: [{ city: 'Gainesville', state: 'FL' }],
        office_name: 'Gator Dental',
      },
      offer_final_reciever: null,
      job_datetime: '2026-03-15T14:00:00.000Z',
      job_filled_datetime: null,
      workerClassification: 'contractor',
      createdAt: '2026-02-10T07:00:00.000Z',
      workingHours: 6,
      local_start_time: '09:00 am',
      local_end_time: '04:00 pm',
      local_date: 'Sun, Mar 15, 2026',
      counterExpirationTime: '',
    },
    {
      _id: '698aef1e98b7550011723b09',
      id: '698aef1e98b7550011723b09',
      rate: 42,
      profession: 'RDH',
      subProfession: null,
      job_status: 'filled',
      status: 'filled',
      is_cancelled: false,
      offer_owner: {
        _id: '65833147094d4d001184f4b6',
        id: '65833147094d4d001184f4b6',
        address: [{ city: 'Tallahassee', state: 'FL' }],
        office_name: 'Capital Dental',
      },
      offer_final_reciever: {
        _id: '65833147094d4d001184f503',
        id: '65833147094d4d001184f503',
        first_name: 'Mike',
        last_name: 'Brown',
      },
      job_datetime: '2026-03-08T13:00:00.000Z',
      job_filled_datetime: '2026-02-10T08:00:00.000Z',
      workerClassification: 'contractor',
      createdAt: '2026-02-06T12:00:00.000Z',
      workingHours: 8,
      local_start_time: '08:00 am',
      local_end_time: '05:00 pm',
      local_date: 'Sun, Mar 08, 2026',
      counterExpirationTime: '',
    },
    {
      _id: '698aef1e98b7550011723b10',
      id: '698aef1e98b7550011723b10',
      rate: 33,
      profession: 'DA',
      subProfession: null,
      job_status: 'open',
      status: 'open',
      is_cancelled: false,
      offer_owner: {
        _id: '65833147094d4d001184f4b7',
        id: '65833147094d4d001184f4b7',
        address: [{ city: 'Pensacola', state: 'FL' }],
        office_name: 'Emerald Coast Dental',
      },
      offer_final_reciever: null,
      job_datetime: '2026-03-20T14:00:00.000Z',
      job_filled_datetime: null,
      workerClassification: 'contractor',
      createdAt: '2026-02-10T06:00:00.000Z',
      workingHours: 7,
      local_start_time: '09:00 am',
      local_end_time: '04:00 pm',
      local_date: 'Fri, Mar 20, 2026',
      counterExpirationTime: '',
    },
    {
      _id: '698aef1e98b7550011723b11',
      id: '698aef1e98b7550011723b11',
      rate: 36,
      profession: 'RDH',
      subProfession: null,
      job_status: 'open',
      status: 'open',
      is_cancelled: false,
      offer_owner: {
        _id: '65833147094d4d001184f4b8',
        id: '65833147094d4d001184f4b8',
        address: [{ city: 'Boca Raton', state: 'FL' }],
        office_name: 'Palm Beach Dental',
      },
      offer_final_reciever: null,
      job_datetime: '2026-03-18T13:00:00.000Z',
      job_filled_datetime: null,
      workerClassification: 'contractor',
      createdAt: '2026-02-09T17:00:00.000Z',
      workingHours: 8,
      local_start_time: '08:00 am',
      local_end_time: '05:00 pm',
      local_date: 'Wed, Mar 18, 2026',
      counterExpirationTime: '',
    },
    {
      _id: '698aef1e98b7550011723b12',
      id: '698aef1e98b7550011723b12',
      rate: 29,
      profession: 'DA',
      subProfession: null,
      job_status: 'open',
      status: 'open',
      is_cancelled: false,
      offer_owner: {
        _id: '65833147094d4d001184f4b9',
        id: '65833147094d4d001184f4b9',
        address: [{ city: 'Clearwater', state: 'FL' }],
        office_name: 'Clearwater Family Dental',
      },
      offer_final_reciever: null,
      job_datetime: '2026-03-22T14:00:00.000Z',
      job_filled_datetime: null,
      workerClassification: 'contractor',
      createdAt: '2026-02-10T05:00:00.000Z',
      workingHours: 6,
      local_start_time: '09:00 am',
      local_end_time: '04:00 pm',
      local_date: 'Sun, Mar 22, 2026',
      counterExpirationTime: '',
    },
  ],
};

export const useJobList = () => {
  const [filters, setFilters] = useState({
    page: 1,
    limit: 15,
    sortField: 'createdAt',
    sortOrder: 'desc',
    jobStatus: 'all',
    searchText: '',
    profession: '',
    subProfession: '',
    specialtyRdh: '',
    specialtyDa: '',
    workerClassification: '',
    ram: '',
    dsoName: '',
    dsoManager: '',
    state: '',
    startDate: null,
    endDate: null,
    dsoRamIds: '',
    dsoId: '',
    dateRange: {
      startDate: null,
      endDate: null,
      key: 'selection',
    },
  });

  // TODO: ARF-1696 — replace mock data with useQuery + real API call
  const data = MOCK_RESPONSE.response;
  const isLoading = false;
  const { total } = MOCK_RESPONSE;
  const { totalFiltered } = MOCK_RESPONSE;
  const totalPages = Math.ceil(totalFiltered / filters.limit) || 1;

  const handleFilterChanged = useCallback((type, value) => {
    setFilters((prev) => ({ ...prev, [type]: value, page: 1 }));
  }, []);

  const handlePageChanged = useCallback((page) => {
    setFilters((prev) => ({ ...prev, page }));
  }, []);

  const handleSortChanged = useCallback((selectedColumn, sortDirection) => {
    setFilters((prev) => ({
      ...prev,
      sortField: selectedColumn.sortField,
      sortOrder: sortDirection,
    }));
  }, []);

  // TODO: ARF-1696 — replace with queryClient.invalidateQueries or refetch
  const reloadJobs = useCallback(() => {
    setFilters((prev) => ({ ...prev }));
  }, []);

  return {
    data,
    filters,
    isLoading,
    total,
    totalFiltered,
    totalPages,
    handleFilterChanged,
    handlePageChanged,
    handleSortChanged,
    reloadJobs,
  };
};
